import React, { Component } from "react";
import { connect } from "react-redux";
import {
  retrieveTutorials,
  findTutorialsByTitle,
  // findTutorialsByAuthor,
  // deleteAllTutorials,
} from "../actions/tutorials";
import { Link } from "react-router-dom";

// the tutorials list is very similar to the tutorial component
// and the add tutorial component, but it does do more.
// again... yuck to class based react component.... should be refactored to hooks
class TutorialsList extends Component {
  constructor(props) {
    super(props);
    this.onChangeSearchTitle = this.onChangeSearchTitle.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.setActiveTutorial = this.setActiveTutorial.bind(this);
    this.findByTitle = this.findByTitle.bind(this);
    // this.findByAuthor = this.findByAuthor.bind(this);
    // this.removeAllTutorials = this.removeAllTutorials.bind(this);

    this.state = {
      currentTutorial: null,
      currentAuthor: null,
      currentIndex: -1,
      searchTitle: "",
      searchAuthor: "",
    };
  }

  // refactoring will remove this
  componentDidMount() {
    this.props.retrieveTutorials();
  }

  // our input text field sets a string to search
  onChangeSearchTitle(e) {
    const searchTitle = e.target.value;
    this.setState({
      searchTitle: searchTitle,
    });
  }
  // onChangeSearchAuthor(e) {
  //   const searchAuthor = e.target.value;
  //   this.setState({
  //     searchAuthor: searchAuthor,
  //   });
  // }

  // we refresh data when we find by title, we clear the current tutorial
  // and set the current index to the end of the list
  refreshData() {
    this.setState({
      currentTutorial: null,
      currentIndex: -1,
    });
  }

  // to set a active tutorial we must have the index in the array of objects
  // and the tutorial itself. I suspect you could refactor then just get
  // either the id from the tutorial or the tutorial from the id
  setActiveTutorial(tutorial, index) {
    this.setState({
      currentIndex: index,
      currentTutorial: tutorial,
    });
  }
  // setActiveAuthor(tutorial, index) {
  //   console.log("all tutorials: ", tutorial);
  //   // this.setState({
  //   //   currentIndex: index,
  //   //   currentAuthor: tutorial,
  //   // });
  // }

  // very destructive so currently not in play
  // removeAllTutorials() {
  //   this.props
  //     .deleteAllTutorials()
  //     .then((response) => {
  //       console.log(response);
  //       this.refreshData();
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //     });
  // }

  // clear the state for a tutorial and its index then aka refresh
  // then call method to find tutorial by title...
  findByTitle() {
    this.refreshData();
    this.props.findTutorialsByTitle(this.state.searchTitle);
  }
  // findByAuthor() {
  //   this.refreshData();
  //   this.props.findTutorialsByAuthor(this.state.searchAuthor);
  // }

  // finally we render a list and if a line item is clicked we additionally
  // render the tutorial that matches the line, how? by setting currentTutorial or not
  render() {
    const {
      // searchAuthor,
      // currentAuthor,
      searchTitle,
      currentTutorial,
      currentIndex,
    } = this.state;
    const { tutorials } = this.props;

    return (
      <div className="list row">
        <div className="col-md-8">
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search by title"
              value={searchTitle}
              onChange={this.onChangeSearchTitle}
            />
            <div className="input-group-append">
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={this.findByTitle}
              >
                Search
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <h4>Tutorials List</h4>
          <ul className="list-group">
            {tutorials &&
              tutorials.map((tutorial, index) => (
                <li
                  className={
                    "list-group-item " +
                    (index === currentIndex ? "active" : "")
                  }
                  onClick={() => this.setActiveTutorial(tutorial, index)}
                  key={index}
                >
                  {tutorial.title}
                </li>
              ))}
          </ul>
          {/* commented out this remove all button bc too destructive */}
          {/* <button
            className="m-3 btn btn-sm btn-danger"
            onClick={this.removeAllTutorials}
          >
            Remove All
          </button> */}
        </div>
        <div className="col-md-6">
          {currentTutorial ? (
            <div>
              <h4>Selected Tutorial</h4>
              <div>
                <label>
                  <strong>Title:</strong>
                </label>{" "}
                {currentTutorial.title}
              </div>
              <div>
                <label>
                  <strong>Description:</strong>
                </label>{" "}
                {currentTutorial.description}
              </div>
              <div>
                <label>
                  <strong>Author:</strong>
                </label>{" "}
                {currentTutorial.author || "Unknown"}
              </div>
              <div>
                <label>
                  <strong>Status:</strong>
                </label>{" "}
                {currentTutorial.published ? "Published" : "Pending"}
              </div>

              <Link
                to={"/tutorials/" + currentTutorial.id}
                className="badge badge-warning"
              >
                Edit
              </Link>
            </div>
          ) : (
            <div>
              <br />
              <p>Click a Tutorial...</p>
            </div>
          )}
        </div>

        {/* all json */}
        {/* <pre>{JSON.stringify(tutorials, undefined, 2)}</pre> */}
        {/* show data that matches one specific author */}
        {/* <pre>
          {JSON.stringify(
            tutorials.filter((i) => i.author === "No one"),
            undefined,
            2
          )}
        </pre> */}
        {/*
        // replacing filter with find works but include does not
        <pre>
          {JSON.stringify(
            tutorials.find((i) => i.author === "No one"),
            undefined,
            2
          )}
        </pre> */}

        {/* true or false ? is this author in this list of objects?
        why ask? bc we will want to check if the author exists somehow
        when we are authenticating... this will not actually work but it was
        an idea....
        */}
        {/* <pre>
          {JSON.stringify(
            tutorials.filter((i) => i.author === "No one").length > 0,
            undefined,
            2
          )}
        </pre> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tutorials: state.tutorials,
  };
};

export default connect(mapStateToProps, {
  retrieveTutorials,
  findTutorialsByTitle,
  // findTutorialsByAuthor,
  // deleteAllTutorials,
})(TutorialsList);
